import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';


@Component({
  selector: 'show-provider',
  templateUrl: './show-provider.component.html',
  styleUrls: ['./show-provider.component.scss']
})
export class ShowProviderComponent implements OnInit {
  providerObservable: FirebaseObjectObservable<any>;
  provider: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService
  ) { }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.providerObservable = this.dbService.getProvider(params['key']);
      this.providerObservable.subscribe(provider => {
        this.provider = provider;
      });
    });
  }

  onEditClicked() {
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked() {
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onConfirmDeletePost() {
    this.onHideDeleteModal()
    this.dbService.deleteProvider(this.provider.$key);
    this.router.navigate([`/providers`]);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/show-provider/show-provider.component.ts